<template>
  <StatusCard
    :cor="card.situacao.cor"
  >
    <div style="display:flex; flex-flow: row nowrap;">
      <OcorrenciaItem
        :row="card"
        style="flex: 1; margin: 0"
      />
      <StatusItem
        :column=" { field: 'situacao', title: 'Situação' }"
        :row="card"
        style="flex: 1;  position: relative; top: 10px"
      />
      <DataItem
        :column="{ field: 'data_registro', title: 'Data solicitação' }"
        :row="card"
        style="flex: 1; position: relative; top: 10px"
      />
      <AcoesWidget v-if="showWidgetActions" :row="card" />
    </div>
  </StatusCard>
</template>
<script>
import DataItem from '@/components/listagemColumn/DataItem.vue'
import OcorrenciaItem from '@/components/listagemColumn/OcorrenciaItem'
import StatusCard from '@/components/cards/StatusCard'
import StatusItem from '@/components/listagemColumn/StatusItem'
import AcoesWidget from '@/components/TemplateSolicitacao/componentes/AcoesWidget'

export default {
  name: 'ListaStatusCard',
  components: { AcoesWidget, DataItem, OcorrenciaItem, StatusCard, StatusItem },
  props: {
    card: {},
    showWidgetActions: {
      type: Boolean,
      default: false
    }
  }
}
</script>
